export default __webpack_public_path__ + "static/media/keys_wasd.e78064aa.png";